// global
export const Fetch_Meta = 'Fetch_Meta';
export const Reload_Meta = 'Reload_Meta';
export const Should_Pagination = 'Should_Pagination';

// global-plugins
export const Load_Google_Analytics = 'Load_Google_Analytics';

// home
export const Fetch_Home_Posts_List = 'Fetch_Home_Posts_List';
export const Set_Home_Posts_List = 'Set_Home_Posts_List';

// archives
export const Fetch_Archives_Posts_List = 'Fetch_Archives_Posts_List';
export const Set_Archives_Posts_List = 'Set_Archives_Posts_List';
export const Time_Line_List = 'Time_Line_List';

// categories
export const Fetch_Categories = 'Fetch_Categories';
export const Set_Categories = 'Set_Categories';
export const Fetch_Related_Posts_Of_Category = 'Fetch_Related_Posts_Of_Category';
export const Set_Related_Posts_Of_Category = 'Set_Related_Posts_Of_Category';
export const Categories_Tree = 'Categories_Tree';

// tags
export const Fetch_Tags = 'Fetch_Tags';
export const Set_Tags = 'Set_Tags';
export const Fetch_Related_Posts_Of_Tag = 'Fetch_Related_Posts_Of_Tag';
export const Set_Related_Posts_Of_Tag = 'Set_Related_Posts_Of_Tag';

// detailable
export const Fetch_Detailable_Target = 'Fetch_Detailable_Target';
export const Set_Detailable_Target = 'Set_Detailable_Target';



// WEBPACK FOOTER //
// ./src/store/types.ts